import { BreakpointObserver } from '@angular/cdk/layout';
import { CdkPortalOutlet } from '@angular/cdk/portal';
import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ToastConfig } from '@ngxpert/hot-toast';
import { wzBreakPoints } from '@wz-constants';
import { AuthenticationModels, ConfigurationModels } from '@wz-models';
import { LoadingService } from '@wz-services';
import { AutoUnsubscribeComponent } from '@wz-utilities/auto-unsubscribe.component';
import { dispatchFillFormEvent } from '@wz-utilities/window.utilities';
import * as $ from 'jquery';
import { takeUntil } from 'rxjs/operators';
import { AppTunnelModule } from './app-tunnel.module';
import { AfiAuthenticationService } from './services/tunnel-authentication.service';
import { TunnelNavigationService } from './services/tunnel-navigation.service';
@Component({
  selector: 'wz-app-tunnel',
  imports: [RouterOutlet, AppTunnelModule],
  templateUrl: './app-tunnel.component.html',
  styleUrl: './app-tunnel.component.scss',
  schemas: [],
})
export class AppTunnelComponent
  extends AutoUnsubscribeComponent
  implements OnInit
{
  user!: AuthenticationModels.Broker;
  toasterConfig!: ToastConfig;

  isSmallScreen!: boolean;
  canDisplayed: boolean = true;
  private timeoutID: any;

  private click = 0;
  private timeout: any;
  loading: boolean = true;
  isHeader: boolean = false;

  @ViewChild(CdkPortalOutlet, { static: true }) portalOutlet!: CdkPortalOutlet;

  @ViewChild('target', { static: true }) target!: ElementRef;
  isHovering = false;
  displayM: boolean = false;
  isDisplayLandbot: boolean = false;
  constructor(
    private breakpointObserver: BreakpointObserver,
    config: ConfigurationModels.Configuration,
    private tunnelAuthService: AfiAuthenticationService,
    private tunnelNavService: TunnelNavigationService,
    dateAdapter: DateAdapter<any>,
    private loadingService: LoadingService,
    public element: ElementRef,
    private router: Router,
    private location: Location,
  ) {
    super();
    this.toasterConfig = config.toasterConfig;

    // Open the sidenav by default on md+
    this.breakpointObserver
      .observe(wzBreakPoints.sm.down as any)
      .subscribe((bps) => {
        this.isSmallScreen = bps.matches;
      });

    dateAdapter.setLocale('fr');
    //*/
  }

  //*/
  ngOnInit() {
    this.loadingService.loadingSubject.subscribe((loading: boolean) => {
      this.loading = loading;
    });

    this.tunnelAuthService.$user
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: any) => {
        this.user = user;
        if (user == null) {
          //this.forceGetAccessToken();
        }
      });

    this.urlLandbot();
    this.isSlugOriginParam();
    this.handlePopupClose();
    this.applyStylesAndImages();
  }

  ngAfterViewInit(): void {}

  goToHome() {
    this.tunnelNavService.goToCarInsuranceQuotation();
  }

  fillForm() {
    this.click++;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      this.click = 0;
    }, 500);

    if (this.click === 2) {
      this.click = 0;
      dispatchFillFormEvent();
    }
  }

  toggleModdal($event: any) {
    let parameterCanDisplayModal = localStorage.getItem('displayModal');
    if (
      parameterCanDisplayModal == null ||
      parameterCanDisplayModal == undefined
    ) {
      this.timeoutID = setTimeout(() => {
        this.displayM = true;
        localStorage.setItem('displayModal', 'hidden');
      }, 5000);
    } else {
      if (parameterCanDisplayModal == 'display') {
        this.timeoutID = setTimeout(() => {
          this.displayM = true;
          localStorage.setItem('displayModal', 'hidden');
        }, 5000);
      } else {
        if (this.timeoutID == undefined || this.timeoutID == null) {
          -localStorage.setItem('displayModal', 'display');
        }
      }
    }
  }

  checkEvent($event: any) {
    if (this.timeoutID != null || this.timeoutID != undefined) {
      clearTimeout(this.timeoutID);
    }
  }

  closeModal() {
    this.displayM = false;
    setTimeout(() => {
      localStorage.setItem('displayModal', 'display');
    }, 300000);
  }

  clickOutside($event: any) {
    var pol = document.getElementById('infoModal');
    if ($event.target == pol) {
      this.closeModal();
    }
  }

  private forceGetAccessToken() {
    this.tunnelAuthService.forceGetAccessToken().subscribe((resp) => {
      this.tunnelAuthService.impersonate(resp);
    });
  }

  isSlugQuoteRequest() {
    let parameter_codeOrigin = localStorage.getItem('codeOrigin');
    let condition_headers = [
      'mutuellecom',
      'mutuelleonline',
      'Video',
      'afisante_affiliation',
      'mutuelleonline_affiliation',
      'labonnemutuelle_affiliation',
      'assuranceetmutuelle_affiliation',
      'Mutuelle.com_affiliation',
    ];
    if (
      parameter_codeOrigin &&
      condition_headers.includes(parameter_codeOrigin)
    ) {
      $.default('body.height-auto-iframe').css('height', 'auto');
      return false;
    } else {
      $.default('body.height-auto-iframe').css('height', '100%');
      return true;
    }
  }

  applyStylesAndImages() {
    // AFI Sante
    this.updateDOMButtonEconomise('afisante_affiliation', 'economiseAfisante');

    // mutuelle online
    this.updateDOMButtonEconomise(
      'mutuelleonline_affiliation',
      'economiseMutuelleOnline',
    );

    // La bonne mutuelle
    this.updateDOMButtonEconomise(
      'labonnemutuelle_affiliation',
      'economiseLaBonneMutuelle',
    );

    // Assurance et mutuelle
    this.updateDOMButtonEconomise(
      'assuranceetmutuelle_affiliation',
      'economiseAssuranceEtMutuelle',
    );
  }

  updateDOMButtonEconomise(expectedCode: string, containerClass: string) {
    const parameterCodeOrigin = localStorage.getItem('codeOrigin');
    if (parameterCodeOrigin === expectedCode) {
      this.addClassToButton(containerClass);
    }
  }

  addClassToButton(containerClass: string) {
    const container = document.querySelector('.button-modal') as HTMLElement;
    if (container) {
      container.classList.add(containerClass);
    }
  }
  urlLandbot() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url == '/landbot') {
          this.loading = false;
          this.isHeader = false;
        } else {
          this.loading = true;
          this.isHeader = true;
        }
      }
    });
    this.location.path() == '/landbot'
      ? (this.loading = false)
      : (this.loading = true);
  }

  isSlugOriginParam() {
    let parameter_codeOrigin = localStorage.getItem('codeOrigin');
    let paramater_paramOrigin = localStorage.getItem('paramOrigin');
    let values_origin_param: { [key: string]: string[] } = {
      afisante_affiliation: ['SWM'],
      'Mutuelle.com_affiliation': ['affiliation'],
      labonnemutuelle_affiliation: ['SWM'],
      assuranceetmutuelle_affiliation: ['SWM'],
      mutuelleonline_affiliation: ['SWM'],
    };

    if (
      parameter_codeOrigin &&
      values_origin_param[parameter_codeOrigin] &&
      values_origin_param[parameter_codeOrigin].includes(
        paramater_paramOrigin ?? '',
      )
    ) {
      document.body.style.setProperty('overflow', 'auto', 'important');
    }
  }

  handlePopupClose() {
    const observer = new MutationObserver(() => {
      if (!document.body.classList.contains('tc-modal-open')) {
        this.isSlugOriginParam(); // Réappliquer l'overflow
      }
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  //*/
}

declare global {
  interface Window {
    tC?: any;
    tc_vars?: any;
  }
}
